import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SERVER_URL } from '../../../../config';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';


export default function FullDNAReport() {

    const [files, setFiles] = useState({});
    const [loading, setLoading] = useState(true);
    const token = sessionStorage.getItem('player_token');
    const navigate = useNavigate();

    const reportSections = [
        { key: 'nutrition', label: 'Nutrition' },
        { key: 'soccer', label: 'Soccer' },
        { key: 'fitness', label: 'Fitness' },
    ];

    useEffect(() => {
        const fetchAllReports = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/v2/get-user-all-report`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (response.data.status) {
                    setFiles(response.data.files || {});
                }
            } catch (err) {
                const msg = err?.response?.data?.error?.msg || "Something went wrong.";
                toast.error(msg);
                if (
                    msg.includes("expired") ||
                    msg.includes("invalidated") ||
                    msg.includes("Invalid token") ||
                    msg.includes("token is required")
                ) {
                    setTimeout(() => {
                        navigate('/player/login');
                    }, 2000);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAllReports();
    }, [token, navigate]);

    const downloadFile = async (fileName) => {
        try {
            const response = await axios.get(`${SERVER_URL}/uploads/${fileName}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // 👈 sets the download filename
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <div>
            <div className='flex flex-col lg:flex-row items-center'>

                <div className='w-full lg:w-[40%] flex items-center justify-center'>
                    <img src='/assets/others/Playerinfo.svg' className='h-full object-cover' alt="Player Info" />
                </div>

                <div className='w-full lg:w-[60%] px-4'>
                    <h2 className="text-2xl font-bold text-white mb-6">Your Full DNA Reports</h2>

                    {loading ? (
                        <p className="text-white">Loading reports...</p>
                    ) : (
                        <div className="space-y-4">
                            {reportSections.map(({ key, label }) => {
                                const file = files[key];
                                return (
                                    <div
                                        key={key}
                                        className="bg-black/20 p-4 rounded-lg text-white flex justify-between items-center gap-4"
                                    >
                                        <div className="w-1/3 font-semibold">{label}</div>
                                        <div className="w-1/3 text-sm truncate italic opacity-80">
                                            {file ? file.name : 'No file uploaded'}
                                        </div>
                                        <div className="w-1/3 text-right">
                                            {file ? (
                                                <button
                                                    onClick={() => downloadFile(file.name)}
                                                    className="bg-[#A3B6FF]/40 px-4 py-2 rounded text-white font-semibold hover:bg-[#A3B6FF]/60 transition"
                                                >
                                                    Download
                                                </button>

                                            ) : (
                                                <button
                                                    disabled
                                                    className="px-4 py-2 rounded bg-[#A3B6FF]/20 font-medium opacity-50 cursor-not-allowed"
                                                >
                                                    Download
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    <div className='flex gap-3 items-center justify-end px-2  py-6'>
                        <input type='checkbox' className='scale-125' /> Share with club
                    </div>
                </div>
            </div>
        </div>
    );
}
